module.exports = __webpack_public_path__ + "static/media/law_requirements_2.aba01f7a.png";